import axios from 'axios';
import mixinActions from '../core/actions';
import mixinMutations from '../core/mutations';
import mixinGetters from '../core/getters';

export default {
    namespaced: true,
    state: {
        leagueGroups: [],
        repositoryName: 'leagueGroups',
        filters: {
            name: '',
        },
        itemAddLeague: {},
    },
    mutations: {
        ...mixinMutations(),
        setItemAddLeague(state, itemAddLeague) {
            state.itemAddLeague = itemAddLeague;
        },
    },
    getters: {
        ...mixinGetters(),
        getItemAddLeague(state) {
            return state.itemAddLeague;
        },
    },
    actions: {
        ...mixinActions('leagueGroup'),
        afterCreated(context, data) {
            let leagueGroups = context.getters.getList;
            leagueGroups.push(data.row);
            context.commit('setList', leagueGroups);
            context.commit('PageModule/setTotal', Object.keys(leagueGroups).length, { root: true });
        },
        addLeague(context, data) {
            return axios
                .post('/api/leagueGroup/addLeague', {
                    rows: [
                        {
                            league_group_id: data.league_group_id,
                            custom_league_id: data.custom_league_id,
                        },
                    ],
                })
                .then((response) => {
                    return Promise.resolve(response);
                });
        },
        removeLeague(context, data) {
            return axios
                .post('/api/leagueGroup/delLeague', {
                    rows: [
                        {
                            league_group_id: data.league_group_id,
                            custom_league_id: data.custom_league_id,
                        },
                    ],
                })
                .then((response) => {
                    return Promise.resolve(response);
                });
        },
    },
};
